import styled from 'styled-components'
import BreakpointDown from '../../Media/BreakpointDown'
import BreakpointUp from '../../Media/BreakpointUp'

export const DropDown = styled.div`  
  display:none;
  width:100%;
  background: #fff;
  ${BreakpointUp.xl`
    padding: 20px 0 0;
    position: absolute;
    z-index:1;
    box-shadow: 0px 0px 60px rgba(0, 0, 0, 0.2);
    border-radius: 20px;
    top: calc(100% - 15px);
    left:0;
    min-width: 325px;
    max-width: 325px;
    transform: scale(0.8) translateY(-12%);
  `}
  &.active{
    display:block;
  }
  &.dropdown-mega-menu{
    ${BreakpointUp.xl`      
      min-width: 700px;
      max-width: 700px;
    `}
  }
  &.dropdown-mega-two{
    ${BreakpointUp.xl`  
      min-width: 400px;
      max-width: 400px;
    `}
  }
`

export const DropDownList = styled.ul`
  list-style:none;
  margin:0 0 10px;
  padding:0;
  transition:all 0.5s ease;
  max-height: 438px;
  overflow: hidden;
  overflow-y: auto;
  height: 100%;
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1; 
    border-radius:6px;
  }

  ::-webkit-scrollbar-thumb {
      background: #999; 
      border-radius:6px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #666; 
  }
  @media screen and ( max-height: 680px ){
    max-height: 338px;
  }
  &.dropdown-mega-list{
    ${BreakpointUp.xl`      
      display:flex;
      flex-wrap:wrap;
      justify-content: space-around;
    `}
  }

  &.dropdown-two-mega{
    display:block;
    columns:2;
  }    
  &.dropdown-two-column{
    display:flex;
    flex-wrap:wrap;
    position:relative;
    .dropdown-listItem{
      flex: 0 0 50%;
      max-width: 50%;
    }
  }    
`
export const DropDownListItem = styled.li`
  position:relative;
  margin-bottom:0;
  padding:0 10px;
  ${BreakpointUp.xl`
    padding:0 20px;
  `}
  > a{
    display:flex;
    align-items:center;
    justify-content:space-between;    
    position:relative;
    z-index:1;
    cursor: pointer;
    padding: 10px 0;
    width: 100%;
    font-size: 16px;
    line-height: 24px;
    color:#000;
    font-weight: 500;
    transform: perspective(1px) translateZ(0);    
    transition-property: color;    
    transition-duration: 0.3s;
    /* @media(min-width:1200px){
      &:after{
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom:0;
        display: block;
        height: 1px;
        transition: -webkit-transform .4s cubic-bezier(.77,0,.175,1);        
        transition: transform .4s cubic-bezier(.77,0,.175,1);
        transition: transform .4s cubic-bezier(.77,0,.175,1),-webkit-transform .4s cubic-bezier(.77,0,.175,1);        
        transform: translateZ(0) scaleX(1);
        background: #e9242a;
        transform-origin: right center;    
        transform: translateZ(0) scaleX(0);
      }
    } */
    &:hover{
      color:#e9242a;
      /* @media(min-width:1200px){
        &:after {
          transform-origin: left center;        
          transform: translateZ(0) scaleX(1);
        }  
      } */
    }
  }  
  /* ${BreakpointDown.xl`
    display:flex;
    justify-content:space-between;
    align-items:center;
    position: relative;
  `} */
`
export const DropdownFooter = styled.div`
  position: relative;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  justify-content: center;
  background-color:#484b58;
  overflow: hidden;
  padding: 5px 0;
  @media(min-width:1200px){
    border-radius: 0 0 20px 20px;
  }
  > a{
    color: #fff;
    &:hover {
      color: #E9242A;      
    }
  }

`
export const LinkStatic = styled.span`
  position:relative;
  font-size: 16px;
  line-height: 24px;
  color:#000;
  font-weight: 500;
`
export const DropDownSubList = styled.ul`
  list-style:none;
  margin:0 0 10px;
  padding:0;
`
export const DropDownSubItem = styled.li`
  position:relative;
  margin-bottom:0; 
  > a{
    display:flex;
    align-items:center;
    justify-content:space-between;    
    position:relative;
    z-index:1;
    cursor: pointer;
    padding: 6px 0;
    width: 100%;
    font-size: 14px;
    line-height: 24px;
    color:#373636;
    font-weight: 500;
    transform: perspective(1px) translateZ(0);    
    transition-property: color;    
    transition-duration: 0.3s;
    @media(min-width:1200px){
      &:after{
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom:0;
        display: block;
        height: 1px;
        transition: -webkit-transform .4s cubic-bezier(.77,0,.175,1);        
        transition: transform .4s cubic-bezier(.77,0,.175,1);
        transition: transform .4s cubic-bezier(.77,0,.175,1),-webkit-transform .4s cubic-bezier(.77,0,.175,1);        
        transform: translateZ(0) scaleX(1);
        background: #e9242a;
        transform-origin: right center;    
        transform: translateZ(0) scaleX(0);
      }
    }
    &:hover{
      color:#000;
      @media(min-width:1200px){
        &:after {
          transform-origin: left center;        
          transform: translateZ(0) scaleX(1);
        }  
      }
    }
  }
`
export const DropDownStaticLink = styled.span`
  display:flex;
  align-items:center;
  justify-content:space-between;    
  position:relative;
  z-index:1;
  font-size: 14px;
  line-height: 24px;
  color:#373636;
  font-weight: 500;
  padding: 5px 0;
`